import MailApp from "./contactApp/MailApp"
import MenuTopMinimize from "./MenuTopMinimize"

new MailApp()
new MenuTopMinimize()
